export default __webpack_public_path__ + "static/media/favouriteTopBackground.9cd0046e.jpg";